import React from 'react';
import NextImage, { StaticImageData } from 'next/image';
import { useTheme } from 'styled-components';
import useBreakpoint from 'Common/hooks/useBreakpoint';

import type { Props as LinkProps } from 'Elements/Link/Link';

import Grid, { Col } from 'Components/Grid';

import {
    Container,
    Heading,
    Description,
    List,
    StyledArrowLink,
    Disclaimer,
    Link
} from './IndustryLinks.styled';
import { ArrowLinkProps } from 'Elements/Link/Arrow';

export interface Props {
    heading: string;
    description?: string;
    items: {
        id: string;
        image: {
            alt?: string;
            src: StaticImageData | string;
        };
        link?: LinkProps;
    }[];
    link?: ArrowLinkProps;
    disclaimer?: string;
}

const IndustryLinks: React.FC<Props> = ({ heading, description, items, link, disclaimer }) => {
    const { breakpoints } = useTheme();

    const isDesktop = useBreakpoint(breakpoints.large.value);

    const imageHeight = isDesktop ? 80 : 65;
    const imageWidth = isDesktop ? 160 : 130;

    return (
        <Grid>
            <Col b={12} m={[2, 12]}>
                <Container>
                    <Heading>{heading}</Heading>
                    {description && <Description>{description}</Description>}
                    <List>
                        {items.map(item => (
                            <li key={item.id}>
                                {item.link ? (
                                    <Link
                                        href={item.link.href}
                                        aria-label={item.link.ariaLabel}
                                        target="_blank"
                                        rel="nofollow noopener"
                                    >
                                        <NextImage
                                            src={item.image.src}
                                            alt={item.image.alt || ''}
                                            width={imageWidth}
                                            height={imageHeight}
                                        />
                                    </Link>
                                ) : (
                                    <NextImage
                                        src={item.image.src}
                                        alt={item.image.alt || ''}
                                        width={imageWidth}
                                        height={imageHeight}
                                    />
                                )}
                            </li>
                        ))}
                    </List>
                    {link && <StyledArrowLink {...link} />}
                    {disclaimer && <Disclaimer>{disclaimer}</Disclaimer>}
                </Container>
            </Col>
        </Grid>
    );
};

export default IndustryLinks;
